import { t } from 'i18next'
import moment from 'moment'
import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import {
  ROUTES,
  pendingStatusDocument,
  processStatusDocument,
  closeStatusDocument,
  expiredStatusDocument,
  colorsStatus,
} from 'Utils/constants'
import { generateColorStatus } from 'Utils/functions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquarePen } from '@fortawesome/free-solid-svg-icons'
import { formatDocumentOrigin } from 'Utils/isWebDocumentOrigin'

export function useColumnSearchDispatch() {
  const columns = useMemo(
    () => [
      {
        accessor: 'CustomerNameDocument',
        Header: t('SEARCH_QUOTATION_T.CLIENT_NAME'),
        width: '220px',
        Cell: ({ row }) => row.original.CustomerNameDocument || t('UNKNOWN'),
      },
      {
        accessor: 'DocumentNumber',
        Header: t('SEARCH_QUOTATION_T.NUMBER_DESPACHO_LABEL'),
        width: '200px',
      },
      {
        accessor: 'InvoiceNumber',
        Header: t('SEARCH_QUOTATION_T.INVOICE_NUMBER'),
        width: '185px',
        Cell: ({ row }) => row.original.InvoiceNumber || t('UNKNOWN'),
      },
      {
        accessor: 'SalesOrderNumber',
        Header: t('SEARCH_QUOTATION_T.SELL_ORDER_NUMBER_LABEL'),
        width: '185px',
        Cell: ({ row }) => row.original.SalesOrderNumber || t('UNKNOWN'),
      },
      {
        accessor: 'QuoteNumber',
        Header: t('SEARCH_QUOTATION_T.NUMBER_QUOTATION_LABEL'),
        width: '185px',
        Cell: ({ row }) => row.original.QuoteNumber || t('UNKNOWN'),
      },
      {
        accessor: 'OrderNumber',
        Header: t('SEARCH_QUOTATION_T.NUMBER_ORDER_LABEL'),
        width: '160px',
        Cell: ({ row }) => row.original.OrderNumber || t('UNKNOWN'),
      },
      {
        accessor: 'Origin',
        Header: t('SEARCH_QUOTATION_T.ORIGIN_QUOTATION_LABEL'),
        width: '80px',
        Cell: ({ row }) => formatDocumentOrigin(row.original.Origin),
      },
      {
        accessor: 'CreatedDate',
        Header: t('SEARCH_QUOTATION_T.DATE_QUOTATION_LABEL'),
        width: '110px',
        Cell: ({ row }) =>
          moment(row.original.CreatedDate).format('DD/MM/YYYY'),
      },
      {
        accessor: 'DocHeaderStatusDescription',
        Header: t('SEARCH_QUOTATION_T.STATUS_LABEL'),
        width: '150px',
        Cell: ({ row }) => {
          const status = row.original.DocHeaderStatusDescription
          return (
            <span
              style={{
                backgroundColor: generateColorStatus(
                  status,
                  pendingStatusDocument,
                  processStatusDocument,
                  closeStatusDocument,
                  expiredStatusDocument,
                  colorsStatus
                ),
                borderRadius: '5px',
                padding: '2px 8px',
                display: 'inline-block',
              }}>
              {status}
            </span>
          )
        },
      },
      {
        accessor: 'actions',
        Header: t('ACTION_TABLE_T.ACTIONS_LABEL'),
        width: '80px',
        Cell: ({ row }) => {
          const dispatchUrl = `${ROUTES.orderDispatch}${row.original.DocHeaderId}`
          return (
            <Link
              to={dispatchUrl}
              style={{ display: 'inline-flex', alignItems: 'center' }}
              aria-label="Ver despacho"
              title="Ver despacho"
              data-testid="view-dispatch-link">
              <FontAwesomeIcon
                icon={faSquarePen}
                style={{
                  color: '#3FC5DF',
                  fontSize: '2rem',
                  cursor: 'pointer',
                }}
              />
            </Link>
          )
        },
      },
    ],
    []
  )

  return { columns }
}
